export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz sklep"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bez tytułu"])}
}